export default {
  prevText: 'Föreg',
  nextText: 'Nästa'
}



// WEBPACK FOOTER //
// ./src/components/pagination/locale/sv_SE.js